<div
  *ngIf="assignee.result !== null && (assignee.result === 'Confirmed' || assignee.result === 'Rejected')">
  <div class="d-flex flex-row align-items-center">
    <step-result-icon [title]="assignee.result| i18nStepResult " [result]="assignee.result"></step-result-icon>
      <circ-person-from-login
      [class.inactive]="assignee.result"
      [login]="assignee.user.login"
      [showLogin]="false"
      [showImage]="false"
      [showName]="false"
      ></circ-person-from-login>
    {{assignee.comment}}
    <br/>
  </div>
</div>

